import { Route } from "react-router-dom";
import LandingContainer from "components/views/landing_container";
import GlobalErrorPage from "pages/global_error_page";
import HomePage from "pages/home_page";
import EducationPage from "pages/education_page";
import ExperiencePage from "pages/experience_page";
import ProjectListPage from "pages/project_list_page";
import ProjectDetailPage from "pages/project_detail_page";

const routes = [
  <Route
    key="Landing Page"
    path="/"
    element={<LandingContainer />}
    children={[
      <Route exact path="/" key="Home Page" element={<HomePage />} />,
      <Route
        path="pendidikan"
        key="Education Page"
        element={<EducationPage />}
      />,
      <Route
        path="pengalaman"
        key="Experience Page"
        element={<ExperiencePage />}
      />,
      <Route
        exact
        path="projek"
        key="Project List"
        element={<ProjectListPage />}
      />,
      <Route
        exact
        path="projek/:id"
        key="Project Detail"
        element={<ProjectDetailPage />}
      />,
    ]}
  />,
  <Route key="Not Found" path="*" element={<GlobalErrorPage />} />,
];

export default routes;
